export const isNotNull = <T>(value: T | null): value is T => value !== null
export const isNotUndefined = <T>(value: T | undefined): value is T => value !== undefined
export const isNotUndefinedOrNull = <T>(value: T | null | undefined): value is T =>
  value !== null && value !== undefined
export const isUndefinedOrNull = <T>(value: T | null | undefined): value is T => value === null || value === undefined
